import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit, OnDestroy {
  featureTags = {};
  private destroy$ = new Subject<void>();
  constructor(private title: Title,
    private apiService: ApiService,
    public sharedDataService: SharedDataService,
  ) { }

  ngOnInit(): void {
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));

    if(!!this.featureTags && this.featureTags['sf_header_cart_count']){
      this.sharedDataService.cartResponse$.pipe(
        takeUntil(this.destroy$)
      ).subscribe(res => {        
        this.getCartCount();        
      });
    }
  }

  getCartCount() {
    if (this.apiService.loggedIn()) {
      this.sharedDataService.getOrderData();
    }
  }

  ngOnDestroy(): void {    
    this.destroy$.next();
    this.destroy$.complete();
  }

}
